module.exports = __webpack_public_path__ + "img/281-8b17cf.png";